<template>
  <div class="sp-template">
    <div class="h-title">按订单汇总报表</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="queryForm" class="header-search__form" size="small" label-width="90px">
          <el-form-item label="客户">
            <el-select v-model="queryForm.orgOwner" clearable filterable placeholder="选择客户">
              <el-option v-for="(d, i) in customers" :key="i" :label="d.name" :value="d.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="渠道">
            <el-select v-model="queryForm.channelId" clearable filterable placeholder="选择渠道">
              <el-option v-for="(d, i) in channels" :key="i" :label="d.name" :value="d.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="批次号">
            <el-input v-model.lazy="batchTextArea" type="textarea" placeholder="多个批次号用回车分割"></el-input>
          </el-form-item>

          <el-form-item label="分公司" >   
            <el-select v-model="queryForm.companyId" clearable >
              <el-option v-for="(d, i) in companys" :key="i" :label="d.name" :value="d.id"></el-option>
          </el-select>        
        </el-form-item>   
        
        <el-row>

          <el-form-item label="类型">
            <el-select v-model="queryForm.timeType" clearable>
              <el-option v-for="(d, i) in timeTypes" :key="i" :label="d.name" :value="d.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="开始日期">
            <el-date-picker v-model.lazy="queryForm.startDate" type="date" value-format="yyyy-MM-dd" placeholder="开始日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="结束日期">
            <el-date-picker v-model.lazy="queryForm.endDate" type="date" value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="订单号">
            <el-input v-model.lazy="numberTextArea" type="textarea" placeholder="多个单号用回车分割"></el-input>
          </el-form-item>

        </el-row>

          <el-row>
            <el-form-item>
              <div class="search-form__buttons">
                <el-button v-if="in_configs(80601)" type="primary" size="small" @click="searchTask">搜 索</el-button>
              </div>
            </el-form-item>
            
          </el-row>
        </el-form>
      </div>
      <div class="table-button__groups">
        <div class="button-groups">
          <el-button type="warning" size="small" @click="exportExcel(2)">导出按邮编汇总</el-button>
          <el-button type="warning" size="small" @click="exportExcel(3)">导出按渠道汇总</el-button>
          <el-button type="warning" size="small" @click="exportExcel(4)">导出按客户汇总</el-button>
          <el-button type="primary" v-if="in_configs(80602)" size="small" @click="exportExcel(1)">导出</el-button>
        </div>
      </div>
      <el-table :data="tableData" stripe border style="width: 100%">
        <el-table-column prop="orderId" label="订单号" ></el-table-column>
        <el-table-column prop="customer" label="客户"></el-table-column>
        <el-table-column label="分公司">
          <template slot-scope="scope">
            {{companyMap[scope.row.companyId]}}
          </template>
        </el-table-column>
        <el-table-column label="渠道">
          <template slot-scope="scope">
            {{channelMaps[scope.row.channelId]}}
          </template>
        </el-table-column>
        <el-table-column prop="receivableAmount" label="应收(元)"></el-table-column>
        <el-table-column prop="payableAmount" label="应付(元)"></el-table-column>
        <el-table-column prop="profit" label="利润(元)"></el-table-column>
        <el-table-column prop="createDate" label="创建时间"></el-table-column>
        <el-table-column prop="firstChargeTime" label="发货时间"></el-table-column>
        <el-table-column prop="zipcode" label="邮编"></el-table-column>
        <el-table-column prop="actualWeight" label="实重"></el-table-column>
        <el-table-column prop="volumeWeight" label="体积重"></el-table-column>
        <el-table-column prop="billedWeight" label="计费重"></el-table-column>
        <el-table-column prop="batchId" label="批次号"></el-table-column>
        <el-table-column prop="warehouseName" label="仓库"></el-table-column>
        <el-table-column prop="remarks" label="预警备注"></el-table-column>
      </el-table>

      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryForm.currentPage" :page-sizes="pageSizes" :page-size="queryForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>

    </el-card>
  </div>

</template>

<script>
import { base64ToUint8Array, dateFormat } from '@/util/formUtil'
export default {
  data() {
    return {
      customers: [],
      channels: [],
      channelMaps: {},
      numberTextArea: "",
      batchTextArea: "",
      queryForm: {
        orderIds: [],
        startDate: "",
        endDate: "",
        channelId: "",
        orgOwner: "",
        pageSize: 10,
        currentPage: 1,
        companyId: "",
        timeType: "deliver"
      },
      timeTypes: [
        
        { id: "deliver", name: "发货时间" }
      ],
      tableData: [],
      //分页的数据
      pageSizes: [10, 20, 50, 100],
      total: 0,
      companys: [],
      companyMap: {}
    };
  },
  created() {
    setTimeout(() => {
      this.queryOrderReport();
      this.queryCustomer();
      this.queryChannel();
      this.queryCompany();
    }, 800);
  },
  methods: {
    searchTask() {
      this.queryForm.currentPage = 1;
      this.queryOrderReport();
    },
    queryOrderReport() {
      this.queryForm.export = 0;
      this.queryForm.orderIds = [];
      this.numberTextArea.split(/\n+/gim).forEach((d, i) => {
        if (d && d.trim() != "") {
          this.queryForm.orderIds.push(d);
        }
      });
      this.queryForm.batchIds = [];
      this.batchTextArea.split(/\n+/gim).forEach((d, i) => {
        if (d && d.trim() != "") {
          this.queryForm.batchIds.push(d);
        }
      });

      this.$request1
        .post(
          '/report/order',
          this.queryForm,
          {
            timeout: 10000,
            withCredentials: true,
            // headers: {
            //   "content-type": "application/x-www-form-urlencoded"
            // }
          }
        )
        .then(response => {
          if (response.data.success) {
            this.total = response.data.total;
            this.tableData = response.data.data;
          } else {
            this.total = 0;
            this.tableData = [];
            this.$message.error(response.data.message);
          }
        })
        .catch(error => {});
    },
    //查询客户
    queryCustomer() {
      this.$request1
        .get(
          '/customerAll',
          {
            withCredentials: true
          }
        )
        .then(res => {
          if (res.data.success) {
            this.customers = res.data.data;
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //查询渠道
    queryChannel() {
      this.$request1({
        method: 'GET',
        url: '/system/channel/all',
        withCredentials: true
      })
        .then(res => {
          this.channels = res.data;
          if (this.channels.length > 0) {
            this.channels.forEach(c => {
              this.channelMaps[c.id] = c.name;
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    queryCompany(){
        let _this = this;
        this.$request1({
            method: 'get',
            url: '/system/company',
            params: {
              page:  1,
              pageSize: -1
            }
        })
        .then(response => {          
            _this.companys = response.data.data;
            _this.companys.forEach(a => {
                _this.companyMap[a.id] = a.name;
            });
        })
        .catch(error => {
          console.log(error);
        });
    },
    exportExcel(val) {

      let _this = this;
      this.queryForm.export = val;
      this.queryForm.orderIds = [];
      this.numberTextArea.split(/\n+/gim).forEach((d, i) => {
        if (d && d.trim() != "") {
          this.queryForm.orderIds.push(d);
        }
      });
      this.queryForm.batchIds = [];
      this.batchTextArea.split(/\n+/gim).forEach((d, i) => {
        if (d && d.trim() != "") {
          this.queryForm.batchIds.push(d);
        }
      });

        this.$request1({
          url: '/report/order',
          method: 'post',
          data: this.queryForm,
          responseType: 'blob'
        }).then(res => {
          _this.queryForm.export = 0
          const link = document.createElement('a')
          // let array = base64ToUint8Array(res.data)
          // let blob = new Blob([array])
          let blob = new Blob([res.data])
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          let timestr = dateFormat(new Date(), 'yyyyMMddHHmmss')
          link.setAttribute('download', `order_report_${timestr}.xlsx`)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })

      // var url = tmsSpringUrl + '/report/order';

      // var form = document.createElement("form");
      // form.method = "get";
      // form.action = url;
      // form.target = "_blank";
      // document.body.appendChild(form);

      // for (var key in this.queryForm) {
      //   if(key=='orderIds'){
      //     this.queryForm.orderIds.forEach(a => {
      //       let input = document.createElement("input");
      //       input.type = "hidden";
      //       input.name = "orderIds[]";
      //       input.value = a;
      //       form.appendChild(input);
      //     })          
      //   }else if(key=='batchIds'){
      //     this.queryForm.batchIds.forEach(a => {
      //       let input = document.createElement("input");
      //       input.type = "hidden";
      //       input.name = "batchIds[]";
      //       input.value = a;
      //       form.appendChild(input);
      //     })          
      //   }else {
      //     let input = document.createElement("input");
      //     input.type = "hidden";
      //     input.name = key;
      //     input.value = this.queryForm[key];
      //     form.appendChild(input);
      //   }
      // }

      // var input2 = document.createElement("input");
      // input2.type = "hidden";
      // input2.name = "token";
      // input2.value = this.$getToken()
      // form.appendChild(input2);
      
      // form.submit();

    },
    //分页
    handleSizeChange(val) {
      this.queryForm.currentPage = 1;
      this.queryForm.pageSize = val;
      this.queryOrderReport();
    },
    handleCurrentChange(val) {
      this.queryForm.currentPage = val;
      this.queryOrderReport();
    }
  }
};
</script>

<style lang="scss" scoped>
.el-card__header .el-form .el-input {
  width: 205px;
}
</style>


// WEBPACK FOOTER //
// src/views/report/order.vue